/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../meevomessenger.component.base.ts" />

module Meevo.Plugins.MeevoMessenger {
    class ArrivalsController extends MessengerComponentBase {
        static $inject = [
            '$mdSidenav',
            'meevo.AppSettings',
            'meevo.components.common.BusinessInfoDataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.busy.BusyService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            '$filter',
            '$translate',
            '$q',
            'meevo.plugins.meevoMessenger.meevoMessengerService',
            'meevo.plugins.meevoMessenger.meevoMessengerApiService',
            '$timeout',
            'meevo.components.common.SecurityService',
        ];

        public recipientRoutingList: Array<IRecipientRouteParams> = [
            {
                label: 'LABEL_DISPLAY_CLIENT_PROFILE',
                isRouting: true,
                type: RecipientRouteType.DisplayClientProfile,
                options: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    initialEditSection: 'SECTION_CLIENT_MAIN',
                    initialEditSubSection: null,
                    onClick: this.onClientNavigate.bind(this)
                }
            }, {
                label: 'LABEL_DISPLAY_CLIENT_NOTES',
                isRouting: true,
                type: RecipientRouteType.DisplayClientNotes,
                options: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    initialEditSection: 'SECTION_CLIENT_NOTES',
                    initialEditSubSection: null,
                    onClick: this.onClientNavigate.bind(this)
                }
            }, {
                label: 'LABEL_DISPLAY_FUTURE_APPOINTMENTS',
                isRouting: false,
                type: RecipientRouteType.DisplayFutureAppointments,
                options: {
                    onClick: this.onClientDisplayFutureAppointmentsClick.bind(this)
                }
            }, {
                label: 'LABEL_DISPLAY_CLIENT_TRANSACTION_HISTORY',
                isRouting: true,
                type: RecipientRouteType.DisplayTransactionHistory,
                options: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    initialEditSection: 'SECTION_HISTORY',
                    initialEditSubSection: 'TRANSACTION_HISTORY',
                    onClick: this.onClientNavigate.bind(this)
                }
            }
        ];

        public poweredByEntityName: string = 'Arrivals';

        public autoReplyOptions:  Meevo.Model.IMeevoMessengerAutoReply[] = [
            { type: Meevo.Model.MeevoMessengerAutoRepliesEnum.DefaultAutoReplyMessage, name: this.$translate.instant('LABEL_MEEVO_MESSENGER_DEFAULT_AUTO_REPLY_MESSAGE'), autoReplyMessage: '' },
            { type: Meevo.Model.MeevoMessengerAutoRepliesEnum.OutsideHoursAutoReplyMessage, name: this.$translate.instant('LABEL_MEEVO_MESSENGER_OUTSIDE_HOURS_AUTO_REPLY_MESSAGE'), autoReplyMessage: '' }
        ];
        public checkInFilter: boolean = false;
        public checkOutFilter: boolean = false;
        public appointmentData: IAppointmentDataInfo[];

        //initialize base class variables
        intialSettingsSectionName = 'SECTION_ARRIVALS';
        undeleteConversationType = UndeleteConversationTypesEnum.Arrivals;
        messageLengthLimit = Meevo.Plugins.MeevoMessenger.Constants.MESSAGE_LENGTH_LIMIT;

        constructor(
            protected $mdSidenav: ng.material.ISidenavService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $filter: angular.IFilterService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected $timeout: angular.ITimeoutService,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super(
                $mdSidenav,
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                busyService,
                $rootScope,
                $scope,
                $state,
                contextParams,
                shortCutsService,
                $filter,
                $translate,
                $q,
                meevoMessengerService,
                meevoMessengerApiService,
                $timeout,
                MeevoMessengerClassificationAPI.ARRIVALS,
                securityChecker
            );

            this.notificationClassification = 'ARRIVALS';
        }

        initEventHandler(params) {
            // Call parent implementation first to keep existing subscriptions
            super.initEventHandler(params);

            // Add Arrivals specific subscription
            this.$scope.$on(MeevoMessengerMessages.REFRESH_ARRIVALS_CONVERSATION, () => {
                if (this.meevoMessengerSettings) {
                    this.openConversations(true);
                }
            });
        }

        getOptOutStatus(): any { }

        resetFilters() {
            this.conversationBodyRequest = this.getDefaultConversationBodyRequest(this.isClientMessaging, this.defaultConversationBodyRequest);
            this.checkInFilter = false;
            this.checkOutFilter = false;

            this.getConversationList(this.conversationBodyRequest);
        }

        toggleCheckInOutFilter() {
            if (!this.isMeevoMessengerArrivalsInitialized) return
            this.getConversationList(this.conversationBodyRequest)
        }

        getConversationList(conversationBodyRequest: IConversationBodyRequest, isSilent?: boolean): ng.IPromise<any> {
            if (!isSilent) this.busyService.start();
            return this.meevoMessengerApiService.getConversationList(conversationBodyRequest)
                .then((data: Array<MeevoMessengerConversation>) => {
                    this.getAppointmentStatusByClientId(data);
                }).finally(() => {
                    this.isFirstTimeLogIn = true;
                    this.$rootScope.$broadcast(MeevoMessengerMessages.END_MODULE_PULSING, { classification: this.notificationClassification, isPulsing: false });
                    this.busyService.stop();
                });
        }

        getAppointmentStatusByClientId(conversationList: Array<MeevoMessengerConversation>) {
            const listOfClientIds: Guid[] = conversationList.map((conversation: MeevoMessengerConversation) => conversation.clientId);

            Promise.all([
                this.meevoMessengerApiService.getAppointmentData(listOfClientIds),
                this.meevoMessengerApiService.getAppointmentStatus(listOfClientIds)
            ]).then(responses => {
                if (responses || responses.length) {
                    const appointmentStatus = responses[1];
                    this.appointmentData = responses[0];

                    if (appointmentStatus.length) {
                        this.mergeAppointmentStatusToConversation(appointmentStatus, conversationList);
                        return;
                    }

                    this.conversationPreviewList = conversationList;
                    this.$scope.$apply();
                }
            });
        }

        mergeAppointmentStatusToConversation(data: IArrivalsAppointmentStatus[], conversationList: Array<MeevoMessengerConversation>) {
            const conversationWithAppointments = _.map(conversationList, (conversation: MeevoMessengerConversation) => {
                return _.extend(conversation, _.findWhere(data, { clientId: conversation.clientId }));
            });

            this.conversationPreviewList = this.meevoMessengerService.filterConversationList(this.checkInFilter, this.checkOutFilter, conversationWithAppointments);
            this.$scope.$apply();
        }

        openClientMenu(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/meevoMessenger/modals/clientMenuOptions/clientMenuOptionsModal.html",
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: {
                    recipientRoutingList: this.recipientRoutingList,
                    isClientMessaging: this.isClientMessaging,
                    appointmentData: this.appointmentData,
                    selectedConversationClientId: this.selectedConversation.clientId
                },
                controller: "meevo.plugins.ClientMenuOptionsModalController",
                controllerAs: "vm",
            }

            this.modalService.showCustom(options);
        }

        onClientNavigate(data: IAppointmentServiceCallbackData) {
            this.clientNavigation(null, data.recipientRouting, data.appointmentData.id)
        }

        onClientDisplayFutureAppointmentsClick() {
            this.modalService.hide();
            super.onClientDisplayFutureAppointmentsClick();
        }

        get defaultConversationBodyRequest(): Record<string, any> {
            return {
                classification: MeevoMessengerClassificationAPI.ARRIVALS,
                pageNumber: 0,
                itemsPerPage: 9999
            }
        }

        get isFilterOn(): boolean {
            return this.checkInFilter || this.checkOutFilter;
        }

        get isMeevoMessengerArrivalsInitialized(): boolean {
            return this.meevoMessengerSettings && !!(this.meevoMessengerSettings.locationId) && !!(this.meevoMessengerSettings.tenantId);
        }
        get newConversations() {
            return this.$state['current'].params.newConversations;
        }
    }
    class ArrivalsComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/arrivals/index.html';
        controller = ArrivalsController;
        controllerAs = 'meevoMessenger';
        bindings: any = {
            isAccountInitialized: '=',
            isAutoReplyEnabled: '=',
            sideNavClientInfo: '=',
            isPulsing: '=',
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('arrivalsComponent', new ArrivalsComponent());

}
